<template>
  <div>
    <div class="row">
      <div class="col-9 pt-3 l-m-b-20">
        <h1>Schedule</h1>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-3 d-flex">
        <button class="btn btn-primary" @click="selectedDate = new Date()">Today</button>
        <div class="input-group pl-2">
          <input class="form-control" type="text" v-model="q" @keydown.enter="refetchEvents" />
          <div class="input-group-append">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="row filters">
          <div class="col" />
          <div class="col" v-if="$_can('carriers.index')">
            <select class="form-control" v-model="carrier" @change="refetchEvents">
              <option value="" selected>Carrier</option>
              <option v-for="carrierElement in carriers" :value="carrierElement.id" :key="carrierElement.id">
                {{ carrierElement.name }}
              </option>
            </select>
          </div>
          <div class="col">
            <select class="form-control" v-model="company" @change="refetchEvents">
              <option value="" selected>Company</option>
              <option v-for="companyElement in companies" :value="companyElement.id" :key="companyElement.id">
                {{ companyElement.name }}
              </option>
            </select>
          </div>
          <div class="col">
            <select class="form-control" v-model="moveSize" @change="refetchEvents">
              <option value="" selected>Move Size</option>
              <option v-for="moveSizeElement in moveSizes" :value="moveSizeElement.id" :key="moveSizeElement.id">
                {{ moveSizeElement.name }}
              </option>
            </select>
          </div>
          <div class="col">
            <datepicker v-model="moveDate" name="moveDate" placeholder="Move Date" input-class="form-control py-2"
                        :format="dateFormatter" @change="refetchEvents"
            />
          </div>
          <div class="col">
            <select class="form-control" v-model="status" @change="refetchEvents">
              <option value="" selected>Status</option>
              <option v-for="jobStatus in jobStatuses" :value="jobStatus.id" :key="jobStatus.id">
                {{ jobStatus.name }}
              </option>
            </select>
          </div>
          <div class="col">
            <div class="col-md-12 check-field">
              <label for="show-completed"
                     :class="{'check-open' : showCompleted}"
                     @click.prevent="toggleShowCompleted"
              ><span
                class="checkmark"
              /> Show completed
                <input type="checkbox"
                       id="show-completed"
                       v-model="showCompleted"
                       class="btn-check"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1">
        <button class="btn btn-primary" @click="clearFilters"
                :disabled="!carrier && !company && !moveSize && !moveDate && !status && !balance && !showCompleted"
        >
          Clear
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12" :class="[loading && !events.length ? 'events-loading' : '']">
        <VueCal
          ref="calendar"
          active-view="month"
          events-on-month-view="short"
          show-week-numbers
          :disable-views="['years', 'year']"
          :events="events"
          :selected-date="selectedDate"
          :on-event-click="onEventClick"
          @ready="fetchEvents"
          @view-change="fetchEvents"
        />
      </div>
      <div class="loader-circle" v-show="loading && !events.length" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment/moment';
import Errors from '../../classes/Errors';
import Date from '../../classes/Date';

export default {
  name: 'Schedule',
  components: {
    VueCal,
    Datepicker,
  },
  data() {
    return {
      balance: '',
      carrier: '',
      company: '',
      endDate: '',
      errors: new Errors(),
      events: [],
      loading: false,
      moveSize: '',
      moveDate: '',
      q: '',
      selectedDate: '',
      selectedEvent: {},
      showCompleted: false,
      startDate: '',
      status: '',
    };
  },
  computed: {
    ...mapState({
      jobs: state => state.jobs.jobs.data,
      carriers: state => state.carriers.carriers.data,
      companies: state => state.companies.companies.data,
      moveSizes: state => state.values.moveSizes,
      jobStatuses: state => state.values.jobStatuses,
    }),
  },
  watch: {
    startDate() {
      this.loading = true;
    },
  },
  methods: {
    clearFilters() {
      this.carrier = '';
      this.company = '';
      this.moveSize = '';
      this.moveDate = '';
      this.status = '';
      this.balance = '';
      this.refetchEvents();
    },
    clearSearch() {
      this.q = '';
      this.refetchEvents();
    },
    dateFormatter(date) {
      this.moveDate = Date.formattedDate(date);
      this.refetchEvents();
      return this.moveDate;
    },
    fetchEvents({ startDate, endDate }) {
      this.startDate = startDate;
      this.endDate = endDate;
      const withCompleted = this.showCompleted ? '&show_completed=1' : '';
      this.loading = true;
      axios
        .get(
          `/jobs/calendar?date_from=${startDate.format('MM/DD/YYYY')}&date_to=${endDate.format(
            'MM/DD/YYYY',
          )}&carrier_id=${this.carrier}&company_id=${this.company}&move_size_id=${
            this.moveSize
          }&move_date=${this.moveDate}&status_id=${this.status}&q=${this.q}${withCompleted}`,
        )
        .then(res => {
          res.data.forEach(el => {
            const element = el;
            const customerName = element.title;
            element.title = `<div class="d-flex flex-column align-items-start">
            <div class="font-weight-bold">${moment
              .parseZone(element.start)
              .format('hh:mm A')} - ${moment.parseZone(element.end).format('hh:mm A')}</div>
            <div>${
              el.ref_id
            }</div><div>${customerName}</div></div><div class="d-flex flex-column align-items-end"><div class="d-flex align-items-center">
                <i class="fa fa-male pr-2"></i> ${el.movers}
            </div><div class="d-flex align-items-center"><i class="fa fa-truck pr-2"></i>${
              el.trucks
            }</div></div>`;
            element.url = `/jobs/edit/${el.id}`;
            element.start = moment.parseZone(element.start).format('MM/DD/YYYY hh:mm A');
            element.end = moment.parseZone(element.end).format('MM/DD/YYYY hh:mm A');
            element.class = el.status_id === 16 ? 'vuecal__event-green' : '';
          });
          this.events = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refetchEvents() {
      const withCompleted = this.showCompleted ? '&show_completed=1' : '';
      axios
        .get(
          `/jobs/calendar?date_from=${this.startDate.format(
            'MM/DD/YYYY',
          )}&date_to=${this.endDate.format('MM/DD/YYYY')}&carrier_id=${this.carrier}&company_id=${
            this.company
          }&move_size_id=${this.moveSize}&move_date=${this.moveDate}&status_id=${this.status}&q=${
            this.q
          }${withCompleted}`,
        )
        .then(res => {
          res.data.forEach(el => {
            const element = el;
            const customerName = element.title;
            element.title = `<div class="d-flex flex-column align-items-start">
            <div class="font-weight-bold">${moment
              .parseZone(element.start)
              .format('hh:mm A')} - ${moment.parseZone(element.end).format('hh:mm A')}</div>
            <div>${
              el.ref_id
            }</div><div>${customerName}</div></div><div class="d-flex flex-column align-items-end"><div class="d-flex align-items-center">
                <i class="fa fa-male pr-2"></i> ${el.movers}
            </div><div class="d-flex align-items-center"><i class="fa fa-truck pr-2"></i>${
              el.trucks
            }</div></div>`;
            element.url = `/jobs/edit/${el.id}`;
            element.start = moment.parseZone(element.start).format('MM/DD/YYYY hh:mm A');
            element.end = moment.parseZone(element.end).format('MM/DD/YYYY hh:mm A');
            element.class = el.status_id === 16 ? 'vuecal__event-green' : '';
          });
          this.events = res.data;
        });
    },
    onEventClick(event, e) {
      this.selectedEvent = event;
      window.open(this.$router.resolve(`/jobs/edit/${event.id}`).href, '_blank');
      e.stopPropagation();
    },
    toggleShowCompleted() {
      this.showCompleted = !this.showCompleted;
      this.refetchEvents();
    },
  },
};
</script>
<style scoped>
.input-group .form-control {
  border: 1px solid #ced4da;
  border-right: none;
}
.input-group button.input-group-btn {
  border: 1px solid #ced4da;
  border-left: none;
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/Schedule.vue